import React from 'react'
import { Center, Divider, Text, Box, Container, Card, CardBody, Button, Input, Textarea } from '@chakra-ui/react';
import { MdEmail } from 'react-icons/md';

export default function Contact() {
    return (
        <div data-aos="fade-up">
            <Box display={"flex"} alignItems={"center"} justifyContent={"center"} flexDirection={"column"}>
                <Center height='50px' mt={3}>
                    <Divider orientation='vertical' className='vertical_divider' />
                </Center>
                <Text fontSize={"2xl"}
                    bgGradient='linear(to-l,#2193b0, #6dd5ed)'
                    bgClip='text'
                    fontWeight={"semibold"}
                >
                    Contact Me
                </Text>
            </Box>
            <Container>
                <Text fontSize={"sm"} textAlign={"center"} mb={3}>
                    Have a project idea? Let's work together!
                </Text>
                <Card variant='outline' mb={3}>
                    <CardBody>
                        <form
                            action="https://formspree.io/f/maykzpgb"
                            method="POST"
                        >
                            <Input placeholder='Name' size={"md"} name='name' mb={3} isRequired />
                            <Input placeholder='Email' size={"md"} name='email' mb={3} isRequired />
                            <Textarea placeholder='Your Message' size={"md"} name='msg' mb={3} isRequired />
                            <Button type='submit' fontWeight={"thin"}>Send</Button>
                        </form>
                    </CardBody>
                </Card>
                <Card>
                    <CardBody>
                        <Box display={"flex"} alignItems={"center"} justifyContent={"center"} flexDirection={"column"}>
                            <MdEmail/>
                            <Text fontSize={"sm"}>aryamitrachaudhuri@gmail.com</Text>
                        </Box>
                    </CardBody>
                </Card>
            </Container>
        </div>
    )
}
